import { Flex, Box, IconButton, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import React, { useRef } from 'react';
import { Virtuoso, VirtuosoHandle } from 'react-virtuoso';
import { CommandLineEditorStore } from './command-line-editor-store';

export const STASHED_ITEM_HEIGHT = 37;
export const CommandLineStashedCommands = observer(function CommandLineStashedCommands(props: {
    editorStore: CommandLineEditorStore;
}): React.ReactElement {
    const virtuosoRef = useRef<VirtuosoHandle>(null);
    const totalCount = props.editorStore.stashedItems.length;

    const renderItemContent = (index: number): React.ReactElement => {
        const item = props.editorStore.stashedItems[index];
        return (
            <Flex
                alignItems="center"
                key={index}
                borderTop="sm"
                borderColor="border.default"
                padding="0 8px 0 48px"
                color="text.secondary"
                h={`${STASHED_ITEM_HEIGHT}px`}
                bg="surface.canvas"
                data-testid="cli-stashed-command"
            >
                <Flex alignItems="center" justifyContent="space-between" w="full">
                    <Text fontSize="xl">{item.commandText?.toUpperCase()}</Text>
                    <IconButton
                        aria-label="remove"
                        onClick={() => {
                            props.editorStore.removeStashedCommand(item.id);
                        }}
                        variant="ghost"
                        icon="CloseX"
                    />
                </Flex>
            </Flex>
        );
    };

    //the +1 accounts for an extra space that causes the scrollbar to be visible
    const height = totalCount * STASHED_ITEM_HEIGHT + 1;

    return (
        <Box maxH="full" h={height}>
            <Virtuoso
                style={{ height: '100%', overflowY: 'auto' }}
                ref={virtuosoRef}
                totalCount={totalCount}
                overscan={3}
                itemContent={renderItemContent}
                followOutput="auto"
            />
        </Box>
    );
});
